export const FAILED_PAYMENTS_STRINGS = {
  'section.title': 'Failed Payments To Be Resolved',
  'section.summary.need_attention': 'need your attention.',
  'section.summary.body':
    "We tried to process them but couldn't complete the charge.",
  'section.summary.resolve': 'Resolve now to avoid delays.',
  'section.total': 'Total',
  'section.cta': 'Resolve Now',
  'item.failed_prefix': 'Failed On',
  'item.due_prefix': 'Due in',
  'item.due_days': 'days',
  'item.due_today': 'Due today',
  'item.due_tomorrow': 'Due tomorrow',
  'item.due_overdue': 'Overdue',
  'modal.entry.badge': 'Failed',
  'modal.entry.payment_methods': 'Payment Methods',
  'modal.entry.change': 'Change',
  'modal.options.title': 'There was an issue with\nyour payments.',
  'modal.options.prompt': 'How would you like to resolve it?',
  'modal.footer.help_prefix': 'Questions or concerns?',
  'modal.footer.help_cta': "LET'S TALK",
  'modal.footer.cta': 'Resolve',
  'modal.footer.confirm_and_pay': 'Confirm & Pay',
  'modal.footer.back': 'Back',
  'modal.footer.confirm': 'Confirm',
  'modal.footer.confirm_payment': 'Confirm Payment',
  'modal.footer.done': 'Done',
  'modal.footer.next': 'Next',
  'modal.footer.submit': 'Submit',
  'remaining.title_line_1': 'Catch up on your',
  'remaining.title_line_2': 'failed payments',
  'remaining.subtitle':
    'You still have outstanding balances.\nPlease select which ones you’d like to pay now.',
  'remaining.payment_methods': 'Payment Methods',
  'remaining.footer.pay_now': 'Pay Now',
  'remaining.toast.retry_today': 'We’ll retry the selected balances today.',
  'balances.retry_today_prompt': 'Which payments should we retry today?',
  'balances.schedule_later_prompt':
    'Which balances should we try charging later?',
  'balances.change_payment_method_prompt':
    'Which balances should we retry charging today?',
  'option.retry_today': 'Retry payment\ntoday.',
  'option.schedule_later': 'Schedule the\npayment for later.',
  'option.change_payment_method': 'Change my\npayment method.',
  'option.unable_to_pay': "I'm not able to make\nthis payment.",
  'option.withholding': "I'm withholding all or\npart of this payment.",
  'option.homeowner.retry_today': 'Retry Payment Today',
  'option.homeowner.schedule_later': 'Schedule Payment',
  'option.homeowner.change_payment_method': 'Change Payment Method',
  'option.homeowner.deduct_from_rent': 'Deduct From Rent',
  'option.homeowner.split_it': 'Split It',
  'option.homeowner.split_it_subtitle': 'Up to {count} Monthly Installments',
  'option.homeowner.dispute_charge': 'Dispute Charge',
  'select_home.title': 'Which home would you like\nto start with?',
  'select_home.next_title': 'One down. Which home is\u00A0next?',
  'select_home.next_subtitle':
    '{count} homes left, and this pass will be quicker.',
  'select_home.next_subtitle_singular':
    '1 home left, and this pass will be quicker.',
  'select_home.outstanding_balances': '{count} Outstanding Balances',
  'select_home.outstanding_balance': '1 Outstanding Balance',
  'select_home.resolved': 'Resolved',
  'retry_today.prompt': "Great! We'll try your payment method again today.",
  'retry_today.rescheduled_for': 'Rescheduled For',
  'retry_today.no_method_prompt': "You'll need a payment method first.",
  'retry_today.no_method_description':
    'Add a card or bank account and we can retry this payment today.',
  'retry_today.wire_prompt': 'Great! Send the wire and upload your receipt.',
  'retry_today.wire_description':
    "We'll review it and apply it to the balances you select below.",
  'schedule_later.title': 'Schedule for later',
  'schedule_later.prompt':
    'Ok! When would you like us to retry your payment method?',
  'schedule_later.description':
    'Pick a date to retry the payment. Late fees may apply for dates past the due date.',
  'schedule_later.date_label': 'Retry date',
  'schedule_later.late_fee_chip': '+Late Fee',
  'schedule_later.late_fee_label': 'Late Fee',
  'schedule_later.late_fee_description':
    'As this date is outside of the grace period stipulated in your lease, a late fee will be applied to this payment.',
  'schedule_later.late_fee_description_homeowner':
    'As this date is outside of the grace period stipulated in your agreement, a late fee will be applied to this payment.',
  'change_payment_method.homeowner.prompt':
    'No problem! How would you like to pay?',
  'wire.transfer': 'Wire Transfer',
  'wire.add_method': 'Add a card or bank account',
  'wire.where_title': 'Where should you send it?',
  'wire.copied': 'Copied!',
  'wire.reference_code': 'Reference Code',
  'wire.reference_hint': 'Including this code will speed things up.',
  'wire.account_holder': 'Account Holder',
  'wire.bank': 'Bank',
  'wire.bank_address': 'Bank Address',
  'wire.routing_number': 'Routing Number',
  'wire.account_number': 'Account Number',
  'wire.covering_title': 'What is this wire covering?',
  'wire.upload_title': 'Upload your wire receipt.',
  'wire.upload_cta': 'Upload Documents',
  'wire.upload_hint': 'Drag file here…',
  'wire.upload_error_too_big': '{filename} is {size} — too big.',
  'wire.upload_error_unreadable': "{filename} — we can't read {extension}.",
  'wire.upload_error_too_big_unreadable':
    "{filename} is {size} — too big, and we can't read {extension}.",
  'wire.upload_error_hint':
    'Send a PNG, JPG or PDF under 10 MB. A screenshot of your bank confirmation works.',
  'wire.submit': 'Submit',
  'wire.success.title': 'We got your receipt.',
  'wire.success.subtitle':
    "Rest assured, we'll review your receipt and reach out if we have any questions.",
  'wire.success.reference': 'Reference | {code}',
  'wire.success.pending_review': 'Pending Review | {home}',
  'wire.error.missing_receipt': 'Please upload your wire receipt.',
  'wire.error.missing_covering': 'Please select what this wire covers.',
  'deduct.held_title': "Use the rent we're holding for this home?",
  'deduct.what_changes': 'What changes',
  'deduct.scheduled_title':
    "You'll receive {payout} on {date} instead of {original}.",
  'deduct.scheduled_late_fee_note':
    'As this date is outside of the grace period stipulated in your lease, a {fee} late fee will be applied to this payment.',
  'deduct.no_payout_title':
    "You won't receive a payout on {date} for this home.",
  'deduct.no_payout_note':
    'This outstanding balance is exactly your {date} payout of {amount}, so it uses all of it. Your {nextDate} payout is unaffected, and no late fee applies.',
  'deduct.no_payout_note_carryover':
    'This balance uses your full {date} payout of {amount}. The remaining {remaining} will be deducted from upcoming payouts, and no late fee applies.',
  'deduct.no_payout_note_unavailable':
    "There isn't a payout scheduled for {date}, so we'll deduct this balance from the next available payout. No late fee applies.",
  'deduct.rent_available': 'Rent available · {home}',
  'deduct.rent_scheduled': 'Rent to be collected on {date} for {home}',
  'deduct.rent_collected': 'Rent collected for {home} · disburses {date}',
  'deduct.management_fee': 'Management Fee - {month}',
  'deduct.finance_installment': 'Finance Plan Installment - {month}',
  'deduct.applied_to_your_balance': 'Applied to your balance',
  'deduct.applied_to_this_balance': 'Applied to this balance',
  'deduct.payout_line': 'Your {date} Payout',
  'deduct.payout_note': 'Future payouts remain untouched',
  'deduct.payout_note_carryover':
    'Remaining balance deducted from upcoming payouts',
  'deduct.payout_note_unavailable': 'Deducted from the next available payout',
  'deduct.partial_title':
    'Rent covers most of it. How should we handle the rest?',
  'deduct.covered_by_rent': 'Covered by rent · {home}',
  'deduct.remaining_balance': 'Remaining balance',
  'deduct.charge_remaining_title':
    'When should we charge the remaining {amount}?',
  'deduct.right_now': 'Right Now',
  'deduct.summary_title': 'Payment Summary',
  'deduct.summary_rent_holding': "Rent we're holding for this home",
  'deduct.summary_deducting': 'Deducting from rent',
  'deduct.summary_immediate': 'Immediate payment',
  'deduct.summary_scheduled': 'Payment on {date}',
  'deduct.summary_charging_on': 'Charging {date}',
  'deduct.footer_cta': 'Use Rent & Pay {amount}',
  'deduct.footer_cta_held': 'Pay {amount} From Rent',
  'deduct.footer_cta_scheduled': 'Pay {amount} With Rent',
  'deduct.footer_cta_full_payout': 'Use my full {date} payout',
  'deduct.summary_cc_fee': 'Credit Card Fee',
  'deduct.summary_charging_today': 'Charging today',
  'deduct.summary_total': 'Total Amount',
  'deduct.summary_total_note': '{rent} from rent, {card} on your card today',
  'deduct.summary_total_note_scheduled':
    '{rent} from rent, {card} on your card on {date}',
  'deduct.error.preview': "We couldn't check your rent for this home yet.",
  'success.toast.deduct_from_rent':
    "We'll deduct the selected balances from your rent.",
  'split.prompt': 'How would you like to split the {amount}?',
  'split.due_today': 'Due Today (Upfront)',
  'split.due_today_tooltip':
    'The maximum financeable amount equals monthly rent times months remaining. Any balance above that cap must be paid upfront today.',
  'split.splitting': 'Splitting',
  'split.per_month': '/Mo.',
  'split.apr_line':
    'Including {apr}% APR (${interest}/Mo.) • No Additional Fees',
  'split.due_first': 'Due On The 1st Of Each Month',
  'split.installments': '{count} Monthly Installments',
  'split.months': '{count} Months',
  'split.months_tooltip':
    'Split your balance across the time remaining on your lease.',
  'split.disclosure_prefix': 'By clicking ‘Split It’, I agree to the',
  'split.disclosure_cta': 'TRUTH IN LENDING DISCLOSURES',
  'split.footer_cta': 'Split It!',
  'split.success.title': "You're on a plan.\nNothing else to do.",
  'split.success.on_plan': 'On Installment Plan',
  'split.success.first_note':
    'Now {upfront}. Next {installment} charged {date} · 1 of {count}',
  'split.success.note': 'Next {installment} charged {date} · 1 of {count}',
  'dispute.full_prompt': 'Are you disputing the full amount?',
  'dispute.which_title': 'Which charges are you disputing?',
  'dispute.reason_label': 'Reason',
  'dispute.total_full_pair': "You're disputing both charges",
  'dispute.total_full_single': "You're disputing this charge",
  'dispute.total_full_many': "You're disputing {count} charges",
  'dispute.still_to_resolve': 'Still to resolve',
  'dispute.warning_title':
    'Disputing balances is a serious step, which could result in negative credit infractions.',
  'dispute.warning_body':
    'This payment will be put on hold until it is resolved. either through payment, or payment forgiveness.',
  'dispute.error.missing_choice':
    'Please choose whether you are disputing the full amount.',
  'dispute.error.missing_balance':
    'Please select at least one charge to dispute.',
  'dispute.error.missing_reason': 'Please choose a reason for each charge.',
  'dispute.describe_reason': 'Describe The Reason',
  'dispute.error.missing_reason_detail':
    'Please describe the reason you selected.',
  'dispute.footer_cta_full': 'Submit Dispute',
  'dispute.footer_cta_partial': 'Dispute {amount}',
  'success.toast.dispute':
    'Our team will review the dispute and follow up with next steps.',
  'change_payment_method.title': 'Change payment method',
  'change_payment_method.prompt': 'No problem! How would you like to pay?',
  'change_payment_method.description':
    'Pick a new payment method. The next scheduled retry will use it.',
  'change_payment_method.set_as_default': 'Set as default',
  'unable_to_pay.title': "I'm not able to make this payment",
  'unable_to_pay.description':
    'Tell us how you would like to handle this balance.',
  'unable_to_pay.proceed.prompt':
    'We understand finances can change. How would you like\nto proceed?',
  'unable_to_pay.proceed.partial_payment': 'Make A Partial Payment',
  'unable_to_pay.proceed.unable_anymore': 'Unable To Pay Anymore',
  'unable_to_pay.partial.amount_prompt': 'How much would you like to pay now?',
  'unable_to_pay.partial.amount_placeholder': 'Partial Payment Amount ($)',
  'unable_to_pay.partial.preview_loading':
    'Calculating your payment breakdown...',
  'unable_to_pay.partial.remaining_date_prompt':
    'When should we charge the remaining amount?',
  'unable_to_pay.partial.failed_on': 'Failed On',
  'unable_to_pay.partial.summary_title': 'Payment Summary',
  'unable_to_pay.partial.immediate_payment': 'Immediate Payment',
  'unable_to_pay.partial.charging_today': 'Charging Today',
  'unable_to_pay.partial.remaining_balance': 'Remaining Balance',
  'unable_to_pay.partial.charging_on': 'Charging On',
  'unable_to_pay.partial.total_amount': 'Total Amount',
  'unable_to_pay.partial.pay_now_later': 'Pay {now} Now, {later} Later',
  'unable_to_pay.indefinite.callout':
    'This payment will be put on hold until it is resolved, either through payment, payment forgiveness, or proof of mediation.',
  'unable_to_pay.plan.splitit': 'Split it into smaller installments.',
  'unable_to_pay.plan.scheduled': 'Set up a payment schedule.',
  'unable_to_pay.plan.indefinitely': 'I cannot pay this balance.',
  'withholding.full_payment_prompt': 'Are you withholding the full payment?',
  'withholding.full_payment_yes': 'Yes',
  'withholding.full_payment_no': 'No',
  'withholding.balances_prompt':
    'Which balances are you withholding or disputing?',
  'withholding.fixed_reason': 'Resident is withholding payment.',
  'withholding.warning_title':
    'Withholding rent or disputing balances is a serious step, which could result in eviction or negative credit infractions.',
  'withholding.warning_body':
    'This payment will be put on hold until it is resolved. either through payment, payment forgiveness, or proof of mediation.',
  'withholding.advance_warning_title': 'Paying in advance?',
  'withholding.advance_warning_body':
    'are not due yet. Would you like to proceed?',
  'success.toast': 'Resolution submitted',
  'success.toast.retry_today': 'We’ll retry the selected balances today.',
  'success.toast.schedule_later':
    'We’ll retry the selected balances on {date}.',
  'success.toast.change_payment_method':
    'We’ll retry the selected balances using your new payment method.',
  'success.toast.partial_payment': 'Partial payment scheduled successfully.',
  'success.toast.hold': 'Your payment has been placed on hold.',
  'success.toast.withholding':
    'Our team will review the withholding request and follow up with next steps.',
  'error.generic': 'Something went wrong. Please try again.',
  'error.default_payment_method_update':
    'Payment resolved, but we could not update your default payment method.',
  'error.late_fee_preview':
    'We could not calculate late fees for these dates. Please try again.',
  'error.rent_credit_card_not_allowed':
    'Credit Card payments are not allowed for Rent. Please use ACH.',
  'error.missing_payment_method': 'Please select a payment method.',
  'error.missing_date': 'Please choose a retry date.',
  'error.missing_selected_balance': 'Please select at least one balance.',
  'error.missing_plan': 'Please choose a payment plan.',
  'error.missing_amount': 'Please enter an amount.',
  'error.amount_too_high':
    'Please enter an amount less than or equal to the selected balance total.',
  'error.partial_payment_preview':
    "We couldn't preview this partial payment. Please try again.",
  'error.partial_payment_preview_retry': 'Try again',
  'error.missing_withholding_choice':
    'Please choose whether you are withholding the full payment.',
  'error.missing_withheld_balance':
    'Please select at least one balance to withhold.',
  'error.unresolvable_balances':
    "Some failed payments can't be self-resolved. Please contact Belong support.",
};
